"use client";
import React from "react";

const AIGeneratingOverlay = () => {
  return (
    <div className="h-full w-full flex items-center justify-center">
      <div className="text-center">
        <div className="loading loading-spinner loading-lg mb-4 text-primary"></div>
        <h3 className="text-lg font-semibold mb-2">Generating Document with AI</h3>
        <p className="text-gray-600">This may take a moment...</p>
      </div>
    </div>
  );
};

export default AIGeneratingOverlay;